import { Component, SimpleChange } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-auto-ml-scenario',
  templateUrl: './auto-ml-scenario.component.html',
  styleUrls: ['./auto-ml-scenario.component.scss']
})
export class AutoMlScenarioComponent {
 
  selectedScenario!:string;
  index:number=0;
  constructor(
    public _autoMl:AutoMlService,
    private toast:ToastrService
  ){}



  get driversList(){
    return this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index]?.driversList ?? [];
  }

  get scenarioList(){
    return this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList;
  }


  setSelected(i:number){
    // if(this.index !==i)
    // {

      this.selectedScenario = JSON.stringify(this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[i]);
      this.index=i;
    // }
    // debugger

  }

  

  valueChange(){
    this._autoMl.updateScenarioSet(this.index);
  }

  getPercentage(p_value:number,d_value:number):number{
   return (( p_value - d_value ) / d_value)*100;
  }

  editScenario(i:number){
    this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList.forEach((el:any)=>{
      el.isEdit = false;
    })
    this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[i].isEdit = true;
  }

  deleteScenario(i:number,id:string){
    this._autoMl.deleteScenario(id)
    .subscribe((res:any)=>{
      if(res.status ==='success'){
        this.toast.success(res.message);
        this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList.splice(i,1)
      }
      
    })
  }



  rename(name:string,desc:string,id:string,i:number){
    let  data={
        name:name,
        description:desc
    }
   

    this._autoMl.renameScenario(id,data)
    .subscribe((res:any)=>{
      if(res.message==='Scenario updated successfully'){
        this.toast.success(res.message);
        this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[i].isEdit = false;
      }      
    })


  }


  addNewScenario(){
    this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList.push({driversList: JSON.parse(this._autoMl.initialDriversSet),isEdit:true});
    this._autoMl.runScenario(this.scenarioList.length-1);
    this.index= this.scenarioList.length-1;
    this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index-1].isEdit =false;
  }


  resetToDefault(){
    this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index].driversList = JSON.parse(this._autoMl.initialDriversSet)
    this._autoMl.updateScenarioSet(this.index)
  }

  getStep(s:number,e:number){
    return e-s > 5 ? 1: 0.1;
  }

  setValue(env:any,i:number){
    let item = this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index].driversList[i]
    let a:any=env.target.value;
    a =a.replace(/\,/g,'');
    a =parseInt(a,10);

    if(Number(item.min_value) >= Number(a)){
      this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index].driversList[i].value = item.min_value;
    }
    else if(Number(item.max_value) <= Number(a)){
      this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index].driversList[i].value = item.max_value;
    }
    else{
      this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList[this.index].driversList[i].value = a;
    }

    this._autoMl.updateScenarioSet(this.index);
  }

}
